import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../pages/Customers";
import Login from "../pages/Login";
import Forgot from "../pages/Forgot";
import Jobs from "../pages/Jobs";
import SMS from "../pages/SMS";
import SMSView from "../pages/SMSView";
import TechnicianSMS from "../pages/TechnicianSMS.vue";
import TechnicianSMSView from "../pages/TechnicianSMSView.vue";
import Templates from "../pages/Templates";
import CreateTemplate from "../components/templates/Create";
import CreateCustomer from "../components/customers/Create.vue";
import CreateUser from "../components/users/Create";
import SmsTemplates from "../pages/SmsTemplates.vue";
// import CreateJob from "../components/jobs/Create";
import Users from "../pages/Users";
import JobConfirm from "../pages/JobConfirm";
import JobCancel from "../pages/JobCancel";
import CarMake from "../pages/CarMake";
import CarMakeUnlocking from "../pages/CarMakeUnlocking";
import MechanicalKey from "../pages/MechanicalKey.vue";
import InsertBlade from "../pages/InsertBlade.vue";
import CreateCarMake from "../components/carmake/CreateCarMake.vue";
import createCarMakeUnlocking from "../components/carmake-unlocking/CreateCarMakeUnlocking.vue";
import Technicians from "../pages/Technicians.vue";
import TechniciansCreate from "../components/technicians/Create.vue";
import Fields from "../pages/Fields.vue";
import DispatchSheet from "../pages/DispatchSheet.vue";
import ZipCodes from "../pages/ZipCodes.vue";
import Contract from "../pages/Contract.vue";
import CMP from "../pages/CMP.vue";
import SearchEngine from "../pages/SearchEngine.vue";
import CustomerEmails from "../pages/CustomerEmails.vue";
import KeyLogs from "../pages/KeyLogs.vue";
import ErrorLogs from "../pages/ErrorLogs.vue";
import TechnicianCloseForm from "../pages/TechnicianCloseForm.vue";
import AcceptJob from "../pages/AcceptJob.vue";
import Estimate from "../pages/Estimate.vue";
import EstimateCustomer from "../components/estimate/Create.vue";
import quickLookUpForm from "../pages/QuickLookUpForm.vue";

import { auth } from "../assets/js/firebase";
Vue.use(VueRouter);
let isAuth = (to, from, next) => {
  auth.onAuthStateChanged((user) => {
    if (user) {
      next();
    } else {
      next("/login");
    }
  });
};
let isAuthLogin = (to, from, next) => {
  auth.onAuthStateChanged((user) => {
    if (!user) return next();
    next("/");
  });
};

const routes = [
  {
    path: "/",
    name: "index",
    beforeEnter: isAuth,
    component: Index,
  },

  // {
  //   path: "/estimate",
  //   name: "estimate",
  //   beforeEnter: isAuth,
  //   component: Estimate,
  // },
  {
    path: "/estimate/create",
    name: "estimate-create",
    beforeEnter: isAuth,
    component: EstimateCustomer,
  },
  {
    path: "/estimate/:id",
    name: "estimate-get",
    beforeEnter: isAuth,
    component: EstimateCustomer,
  },
  {
    path: "/manage-estimate",
    name: "manage-estimate",
    beforeEnter: isAuth,
    component: Estimate,
  },
  {
    path: "/jobs",
    name: "jobs",
    beforeEnter: isAuth,
    component: Jobs,
  },
  {
    path: "/car-make",
    name: "car-make",
    beforeEnter: isAuth,
    component: CarMake,
  },
  {
    path: "/car-make/create",
    name: "car-make-create",
    beforeEnter: isAuth,
    component: CreateCarMake,
  },
  {
    path: "/car-make/:id",
    name: "car-make-update",
    beforeEnter: isAuth,
    component: CreateCarMake,
  },
  {
    path: "/car-make-unlocking",
    name: "car-make-unlocking",
    beforeEnter: isAuth,
    component: CarMakeUnlocking,
  },
  {
    path: "/car-make-unlocking/create",
    name: "car-make-unlocking-create",
    beforeEnter: isAuth,
    component: createCarMakeUnlocking,
  },
  {
    path: "/car-make-unlocking/:id",
    name: "car-make-unlocking-update",
    beforeEnter: isAuth,
    component: createCarMakeUnlocking,
  },
  {
    path: "/mechanical-key",
    name: "mechanical-key",
    beforeEnter: isAuth,
    component: MechanicalKey,
  },
  {
    path: "/insert-blade",
    name: "insert-blade",
    beforeEnter: isAuth,
    component: InsertBlade,
  },
  {
    path: "/technicians",
    name: "technicians",
    beforeEnter: isAuth,
    component: Technicians,
  },
  {
    path: "/technicians/create",
    name: "technicians-create",
    beforeEnter: isAuth,
    component: TechniciansCreate,
  },
  {
    path: "/technicians/:id",
    name: "technicians-update",
    beforeEnter: isAuth,
    component: TechniciansCreate,
  },
  {
    path: "/templates",
    name: "templates",
    beforeEnter: isAuth,
    component: Templates,
  },
  {
    path: "/templates/create",
    name: "template-create",
    beforeEnter: isAuth,
    component: CreateTemplate,
  },
  {
    path: "/templates/:id",
    name: "template-update",
    beforeEnter: isAuth,
    component: CreateTemplate,
  },
  {
    path: "/users",
    name: "users",
    beforeEnter: isAuth,
    component: Users,
  },
  {
    path: "/users/create",
    name: "user-create",
    beforeEnter: isAuth,
    component: CreateUser,
  },
  {
    path: "/users/:id",
    name: "user-update",
    beforeEnter: isAuth,
    component: CreateUser,
  },
  {
    path: "/sms",
    name: "sms",
    beforeEnter: isAuth,
    component: SMS,
  },
  {
    path: "/technician-sms",
    name: "technician-sms",
    beforeEnter: isAuth,
    component: TechnicianSMS,
  },
  {
    path: "/login",
    name: "login",
    beforeEnter: isAuthLogin,
    component: Login,
  },
  {
    path: "/forgot",
    name: "forgot",
    beforeEnter: isAuthLogin,
    component: Forgot,
  },
  {
    path: "/customers/create",
    name: "customer-create",
    beforeEnter: isAuth,
    component: CreateCustomer,
  },
  {
    path: "/customers/:id",
    name: "customer-update",
    beforeEnter: isAuth,
    component: CreateCustomer,
  },
  {
    path: "/jobs/:id",
    name: "job-update",
    beforeEnter: isAuth,
    component: CreateCustomer,
  },
  {
    path: "/confirm/:id",
    name: "job-confirm",
    component: JobConfirm,
  },
  {
    path: "/sms-view/:id",
    name: "smsView",
    beforeEnter: isAuth,
    component: SMSView,
  },
  {
    path: "/technician-sms-view/:id",
    name: "technicianSMSView",
    beforeEnter: isAuth,
    component: TechnicianSMSView,
  },
  {
    path: "/cancel/:id",
    name: "job-cancel",
    component: JobCancel,
  },
  {
    path: "/fields",
    name: "fields",
    beforeEnter: isAuth,
    component: Fields,
  },
  {
    path: "/dispatch-sheet",
    name: "dispatch-sheet",
    beforeEnter: isAuth,
    component: DispatchSheet,
  },
  {
    path: "/zip-codes",
    name: "zip-codes",
    beforeEnter: isAuth,
    component: ZipCodes,
  },
  {
    path: "/cmp",
    name: "cmp",
    beforeEnter: isAuth,
    component: CMP,
  },
  {
    path: "/search-engine",
    name: "search-engine",
    beforeEnter: isAuth,
    component: SearchEngine,
  },
  {
    path: "/contract/:id",
    name: "contract",
    component: Contract,
  },
  {
    path: "/sms-templates",
    name: "sms-templates",
    component: SmsTemplates,
    beforeEnter: isAuth,
  },
  {
    path: "/customer-emails",
    name: "customer-emails",
    component: CustomerEmails,
    beforeEnter: isAuth,
  },
  {
    path: "/technician-close-out/:id",
    name: "technician-close-out",
    component: TechnicianCloseForm,
  },
  {
    path: "/accept-job/:id",
    name: "accept-job",
    component: AcceptJob,
  },
  {
    path: "/key-logs",
    name: "key-logs",
    component: KeyLogs,
    beforeEnter: isAuth,
  },
  {
    path: "/error-logs",
    name: "error-logs",
    component: ErrorLogs,
    beforeEnter: isAuth,
  },
  {
    path: "/quick-look-up",
    name: "quick-look-up",
    component: quickLookUpForm,
    meta: {
      hideSidebar: true,
      hideHeader: true,
      hideAction: true,
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
